<template>
    <div class="container-fluid">
        <headerApp :title="this.translate('historialTitle')"></headerApp>
        <div v-if="user && user.mensualidad_actual" class="mensualidad-info form" style="margin-bottom:1em;">
            <h3>Suscripción</h3>
            <div><strong>Mes:</strong> {{ user.mensualidad_actual.mes }}</div>
            <div><strong>Monto:</strong> $ {{ user.mensualidad_actual.monto.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</div>
            <div>
                <strong>Estado:</strong>
                <span v-if="user.mensualidad_actual.pagado" style="color:green;">Pagada</span>
                <span v-else style="color:red;">Pendiente</span>
            </div>
            <div v-if="user.mensualidad_actual.pagado">
                <strong>Fecha de pago:</strong> {{ user.mensualidad_actual.fecha_pago ? user.mensualidad_actual.fecha_pago : '-' }}
            </div>
            <div v-else>
                <strong>Fecha de vencimiento:</strong> {{ user.mensualidad_actual.fecha_vencimiento }}
            </div>
            <div v-if="user.mensualidad_actual.observaciones">
                <strong>Observaciones:</strong> {{ user.mensualidad_actual.observaciones }}
            </div>
        </div>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div class="row">
                        <div id='form' class='form col-xs-11 form-label'>
                            <label for="desde">
                                {{ this.translate('desde') }}
                                <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" :class="'pull-right'"></svg-item>
                            </label>
                            <input id="desde" type="date" v-model="desde" @change="dateChange" :max="hasta">
                                <input id="desdeHora" type="time" v-model="desdeHora" @change="dateChange" style="margin-top: 0.5em;">
                        </div>
                        <div id='form' class='form col-xs-offset-2 col-xs-11 form-label'>
                            <label for="hasta">
                                {{ this.translate('hasta') }}
                                <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" :class="'pull-right'"></svg-item>
                            </label>
                            <input id="hasta" type="date" v-model="hasta" @change="dateChange" :max="hoy" :min="desde">
                                <input id="hastaHora" type="time" v-model="hastaHora" @change="dateChange" style="margin-top: 0.5em;">
                        </div>
                    </div>
                    <div class="row" v-if="settings.metodos_pago && settings.metodos_pago.length > 0">
                        <div id='form' class='form col-xs-24 form-label'>
                            <label for="payment_method">
                                {{ 'Método de pago' }}
                                <svg-item size="24" :icon="'credit-card'"  :color="'--text-color'" :class="'pull-right'"></svg-item>
                            </label>
                            <select id="payment_method" v-model="paymentMethodId" @change="dateChange">
                                <option value="">{{ 'Todos los métodos' }}</option>
                                <option v-for="method in settings.metodos_pago" :key="method.id" :value="method.id">
                                    {{ method.name === 'efectivo' ? 'Efectivo' : (method.name === 'pagoElectronico' ? 'Pago Electrónico' : method.name) }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div id='form' class='form row'>
                        <h1 v-show="computedHistory.length > 0">
                            {{ this.translate('totalViajes') }}: {{ computedHistory.length }}

                        </h1>
                        <h2 v-if="totalPrecio !== '0,00'" >
                            {{ this.translate('totalPrecio') || 'Total cobrado' }}: $ {{ totalPrecio }}
                        </h2>
                        <div v-if="loading" style="text-align:center; margin:2em 0;">
                            <svg-item :icon="'loading'" :color="'--text-color'" size="48" class="spin" />
                            <div>{{ this.translate('cargando') || 'Cargando...' }}</div>
                        </div>
                        <h1 v-else-if="computedHistory.length == 0">
                            {{ this.translate('noHayViajes') }}
                        </h1>
                        <div v-for="item in computedHistory" class="history-item" v-bind:key="item.id">
                            <div class="row">
                                <div v-if="item.chofer && item.chofer.usuario" class="col-xs-24">
                                    <div class="trip-card--left">
                                        <img v-imgSrc="profilePic(item)" class="driver-profile-photo" />
                                    </div>
                                    <div class="driver-description">
                                        <div v-lang.chofer>Chofer</div>
                                        <div class="text-strong">{{ item.chofer.usuario.nombre }} {{ item.chofer.usuario.apellido }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" aria-label="Fecha"></svg-item>
                                    {{ [ item.created_at  ] | moment("DD/MM/YYYY") }}
                                </div>
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'time'"  :color="'--text-color'" aria-label="Hora">></svg-item>
                                    {{ [ item.created_at  ] | moment("HH:mm") }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'gps'"  :color="'--text-color'"  aria-label="Origen">></svg-item>
                                    {{ item.calle }} {{ item.altura >= 0 ? item.altura : '' }}
                                </div>
                                <div class="col-xs-12" v-if="item.km">
                                    <svg-item size="24" :icon="'navigation'"  :color="'--text-color'"  aria-label="Distancia recorrida">></svg-item>
                                    {{ item.km | distanceConverter(settings.medidas_en_millas) | distanceFormatter(settings.medidas_en_millas, 'big') }}
                                </div>
                            </div>
                            <div class="row" v-if="item.dest_nombre">
                                <div class="col-xs-24">
                                    <svg-item size="24" :icon="'lugar'"  :color="'--text-color'"  aria-label="Destino">></svg-item>
                                    {{ item.dest_nombre }}
                                </div>
                            </div>
                            <div class="row" v-if="item.precio">
                                <div class="col-xs-24">
                                    <svg-item size="24" :icon="'money-fill'"  :color="'green'"  aria-label="Precio">></svg-item>
                                    {{ parseFloat(item.precio).toFixed(2) }}
                                </div>
                            </div>
                            <div class="row" v-if="item && item.receipt" style="margin-left: 1em;">
                                <h4>Comprobante de pago</h4>
                                <div>
                                    <strong>Método de pago: </strong>
                                    <span>{{ item.receipt.method }}</span>
                                </div>
                                <div>
                                    <strong>Monto de la transacción: </strong>
                                    <span>$ {{ parseFloat(item.precio).toFixed(2) }}</span>
                                </div>
                                <div>
                                    <strong>Fecha y hora: </strong>
                                    <span>{{ item.created_at }}</span>
                                </div>
                                <div>
                                    <strong>Nombre: </strong>
                                    <span>{{ item.receipt.name ? item.receipt.name : (user.nombre + ' ' + user.apellido) }}</span>
                                </div>
                                <div>
                                    <strong>Tarjeta: </strong>
                                    <span>{{ item.receipt.card }}</span>
                                </div>
                                <div>
                                    <strong>Referencia: </strong>
                                    <span>{{ item.receipt.referenceNumber }}</span>
                                </div>
                                <div>
                                    <strong>Autorización: </strong>
                                    <span>{{ item.receipt.authorizationNumber ? item.receipt.authorizationNumber : 'Anulada'  }}</span>
                                </div>
                                <div>
                                    <strong>Afiliación: </strong>
                                    <span>{{ item.receipt.afilation }}</span>
                                </div>
                                <div>
                                    <strong>Número de Auditoría: </strong>
                                    <span>{{ item.receipt.auditNumber  }}</span>
                                </div>
                                <div style="margin-top: .5em">(01) Pagado Electrónicamente</div>
                            </div>
                            <div class="row" v-if="item && item.canceled_receipt" style="margin-left: 1em;">
                                <h4>Comprobante de anulación</h4>
                                <div>
                                    <strong>Método de pago: </strong>
                                    <span>{{ item.canceled_receipt.method }}</span>
                                </div>
                                <div>
                                    <strong>Fecha y hora: </strong>
                                    <span>{{ item.created_at }}</span>
                                </div>
                                <div>
                                    <strong>Tarjeta: </strong>
                                    <span>{{ item.canceled_receipt.card }}</span>
                                </div>
                                <div>
                                    <strong>Referencia: </strong>
                                    <span>{{ item.canceled_receipt.referenceNumber }}</span>
                                </div>
                                <div>
                                    <strong>Autorización: </strong>
                                    <span>{{ item.canceled_receipt.authorizationNumber ? item.canceled_receipt.authorizationNumber : 'Anulada'  }}</span>
                                </div>
                                <div>
                                    <strong>Afiliación: </strong>
                                    <span>{{ item.canceled_receipt.afilation }}</span>
                                </div>
                                <div>
                                    <strong>Número de Auditoría: </strong>
                                    <span>{{ item.canceled_receipt.auditNumber  }}</span>
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
let defaultProfilePic = require('@/assets/img/default.jpg');

export default {
    name: 'historial',
    data () {
        return {
            desde: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            hasta: moment().format('YYYY-MM-DD'),
            hoy: moment().format('YYYY-MM-DD'),
            desdeHora: '00:00',
            hastaHora: '23:59',
            paymentMethodId: '',
            loading: false
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            tripHistory: 'history/list',
            settings: 'company/config'
        }),
        computedHistory () {
            let arr = [];
            if (this.tripHistory && this.tripHistory.length > 0) {
                this.tripHistory.forEach(function (item) {
                    if (item.payment_success > 0 && typeof item.payment_message === 'string' && item.payment_message.indexOf('{') >= 0) {
                        item.payment_message = JSON.parse(item.payment_message);
                        let paymentInfo = {};
                        try {
                            paymentInfo = JSON.parse(item.payment_info);
                        } catch (ex) {}
                        if (item.payment_message.auditNumber) {
                            item.receipt = Object.assign(paymentInfo, item.payment_message);
                        }
                        if (item.payment_message.auditNumber && item.payment_message.canceled) {
                            item.canceled_receipt = item.payment_message;
                        }
                    }
                    arr.push(item);
                });
            }
            return arr;
        },
        totalPrecio () {
            // Suma todos los precios válidos de los viajes mostrados y lo formatea
            const total = this.computedHistory.reduce((acc, item) => {
                let precio = parseFloat(item.precio);
                return acc + (isNaN(precio) ? 0 : precio);
            }, 0);
            // Formatea con punto para miles y coma para decimales
            return total.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    },
    mounted () {
        this.language = this.$getLang();
        const desdeFull = this.desde + ' ' + this.desdeHora;
        const hastaFull = this.hasta + ' ' + this.hastaHora;
        this.loading = true;
        const params = {
            desde: desdeFull,
            hasta: hastaFull
        };
        if (this.paymentMethodId) {
            params.payment_method_id = this.paymentMethodId;
        }
        this.getHistory(params).finally(() => {
            this.loading = false;
        });
    },
    methods: {
        ...mapActions({
            getHistory: 'history/get'
        }),
        dateChange () {
            const desdeFull = this.desde + ' ' + this.desdeHora;
            const hastaFull = this.hasta + ' ' + this.hastaHora;
            this.loading = true;
            const params = {
                desde: desdeFull,
                hasta: hastaFull
            };
            if (this.paymentMethodId) {
                params.payment_method_id = this.paymentMethodId;
            }
            this.getHistory(params).finally(() => {
                this.loading = false;
            });
        },
        profilePic (item) {
            return item.chofer.foto ? this.$profile(item.chofer.foto) : defaultProfilePic;
        }
    }
};
</script>

<style scoped>
    .spin {
        animation: spin 1s linear infinite;
        display: inline-block;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
   .form {
        padding: 1.4em;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
        margin-top: 1.2em;
        margin-bottom: 1.2em;
    }
    .form-label {
        border-radius: 10px;
    }
    p {
        margin-top: 0;
    }
    h1 {
        font-weight: normal;
        margin-bottom: 1em;
    }
    label {
        display: block;
    }
    .history-item {
        margin-bottom: 1.5em;
        font-size: 0.8rem;
    }
    .history-item hr {
        border-color: var(--text-color);
    }
    .history-item .row{
        margin-top: .8em;
    }
    [type=date], [type=time], select {
        appearance: none;
        -webkit-appearance: none;
        background: transparent;
        border: 0;
        padding: .5em 0;
        width: 100%;
    }
    .driver-profile-photo {
        display: inline-block;
    }
    .driver-description {
        display:inline-block;
        vertical-align: middle;
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Historial.vue